<app-modal
  title="Editar Biometria do Motorista"
  [form]="form"
  (save)="onSave($event)"
>
  <form [formGroup]="form">
    <div class="tds-u-flex tds-u-gap3">
      <div class="tds-u-flex-grow1">
        <div class="tds-row">
          <app-input
            label="CPF do motorista*"
            formControlName="driverId"
            maxLength="14"
            cpfMask
          ></app-input>
        </div>

        <div class="tds-row tds-u-flex-dir-col tds-u-mt2">
          <label class="tds-u-mb1">Anexar Foto da Face*</label>

          <div class="tds-u-flex tds-u-align-center tds-u-gap2">
            <app-button
              text="Selecionar Foto"
              icon="camera"
              (clicked)="fileInput.click()"
            ></app-button>

            <input
              type="file"
              hidden
              #fileInput
              (change)="onFileSelected($event)"
              accept="image/jpeg, image/png"
            />

            @if (selectedFile) {
              <span class="tds-body-01">
                {{ selectedFile!.name }}
              </span>
            }
          </div>
        </div>
      </div>

      @if (previewUrl) {
        <div class="tds-u-flex-shrink0 tds-u-flex tds-u-align-center">
          <div class="image-preview-large-wrapper">
            <img class="image-preview-large" [src]="previewUrl" alt="Preview" />
          </div>
        </div>
      }
    </div>
  </form>
</app-modal>
